import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import s from './Financeiro.module.css';

function fmtBytes(bytes) {
  if (bytes == null) return '—';
  const mb = bytes / (1024 * 1024);
  return mb >= 1024 ? `${(mb / 1024).toFixed(2)} GB` : `${mb.toFixed(1)} MB`;
}

function fmtData(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' });
}

function horasAtras(iso) {
  if (!iso) return Infinity;
  return (Date.now() - new Date(iso).getTime()) / (1000 * 60 * 60);
}

// Bolinha de status: verde (em dia), amarelo (atrasando), vermelho (sumiu/erro).
// Limite de "em dia" é generoso (36h) pra não disparar falso alarme num dia
// em que o backup rodou um pouco mais tarde que o de costume.
function Bolinha({ horas, semDados }) {
  const cor = semDados ? '#b91c1c' : horas <= 36 ? '#16a34a' : horas <= 72 ? '#d97706' : '#b91c1c';
  const titulo = semDados ? 'Sem backup encontrado' : horas <= 36 ? 'Em dia' : horas <= 72 ? 'Atrasando' : 'Muito atrasado';
  return <span title={titulo} style={{ display: 'inline-block', width: 10, height: 10, borderRadius: '50%', background: cor, marginRight: 6 }} />;
}

export default function PainelSuporte() {
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(true);

  const carregar = useCallback(async () => {
    setCarregando(true);
    setErro('');
    try {
      const { data } = await api.get('/painel-suporte/status');
      setDados(data);
    } catch (err) {
      setErro(err.response?.status === 403
        ? 'Acesso restrito — esta tela é só pro usuário de suporte do sistema.'
        : 'Erro ao carregar o status dos backups.');
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  return (
    <div className={s.erpWrap}>
      <div className={s.titleBar}><span>🗄️</span> Backups — Painel Interno</div>
      <div className={s.toolbar}>
        <button className={s.btnErp} onClick={carregar} disabled={carregando}>
          {carregando ? 'Atualizando...' : '↻ Atualizar'}
        </button>
        {dados && <span style={{ fontSize: 11, color: '#888', alignSelf: 'center' }}>Consultado às {fmtData(dados.geradoEm)}</span>}
      </div>

      {erro && <div className={s.erroMsg}>{erro}</div>}

      {dados && (
        <>
          <div style={{ overflowX: 'auto', marginTop: 10 }}>
            <table className={s.tabela}>
              <thead>
                <tr>
                  <th>Site</th>
                  <th>Tamanho do banco</th>
                  <th>Backups locais (VPS)</th>
                  <th>Último backup local</th>
                  <th>Cópia no Google Drive</th>
                  <th>Último no Drive</th>
                </tr>
              </thead>
              <tbody>
                {dados.bancos.map(b => (
                  <tr key={b.chave}>
                    <td style={{ fontWeight: 'bold' }}>{b.nome}</td>
                    <td>{fmtBytes(b.tamanhoBancoBytes)}</td>
                    <td>{b.backupsLocais}</td>
                    <td>
                      <Bolinha horas={horasAtras(b.ultimoBackupLocal)} semDados={!b.ultimoBackupLocal} />
                      {fmtData(b.ultimoBackupLocal)}
                    </td>
                    <td>{b.driveOk ? `${b.backupsDrive} arquivo(s)` : <span style={{ color: '#b91c1c' }}>erro ao consultar</span>}</td>
                    <td>
                      <Bolinha horas={horasAtras(b.ultimoBackupDrive)} semDados={!b.ultimoBackupDrive} />
                      {fmtData(b.ultimoBackupDrive)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{ marginTop: 24 }}>
            <div className={s.titleBar} style={{ fontSize: 14 }}><span>💻</span> Código do projeto (bundle git)</div>
            <div style={{ padding: '10px 4px', fontSize: 13 }}>
              <Bolinha horas={horasAtras(dados.codigo.ultimoBundleDrive)} semDados={!dados.codigo.ultimoBundleDrive} />
              Último envio ao Drive: <strong>{fmtData(dados.codigo.ultimoBundleDrive)}</strong>
              {' '}— {dados.codigo.qtdeNoDrive} versõe(s) guardada(s)
              {!dados.codigo.driveOk && <span style={{ color: '#b91c1c', marginLeft: 8 }}>(erro ao consultar o Drive)</span>}
            </div>
            <div style={{ fontSize: 11, color: '#888', padding: '0 4px' }}>
              Gerado automaticamente a cada 4h, na máquina onde fica o repositório local (roda só quando ela está ligada) —
              se ficar muitos dias sem atualizar, é sinal de que o agendamento parou ou a máquina ficou desligada por muito tempo.
            </div>
          </div>
        </>
      )}
    </div>
  );
}
